import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { z } from 'zod';

export const SalesProductSchema = z.object({
  imageUrl: z.string().describe('이미지 URL'),
  brandName: z.string().describe('브랜드명'),
  goodsNo: z.number().int().describe('상품 고유 번호'),
  goodsName: z.string().describe('상품명'),

  price: z.number().int().describe('가격'),

  totalQuantity: z.number().int().describe('해당 기간 판매 개수'),
  totalCommission: z.number().int().describe('해당 기간 수수료 합산 금액'), // 명세: int64
  linkUrl: z.string().describe('링크 URL'),
});

const ProductSalesRankingResponseSchema = z.object({
  list: z.array(SalesProductSchema).describe('판매 랭킹 상품 리스트'),
});

export type GetProductSalesRankingResponse = MusinsaStandardResponse<
  z.infer<typeof ProductSalesRankingResponseSchema>
>;
